<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <Card>
        <template #content>
          <TabView>
            <TabPanel header="Personal Details" class="p-mt-2">
              <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
<!--                <div class="p-field p-col-12 p-md-12">-->
<!--                  Personal Details-->
<!--                  <hr/>-->
<!--                </div>-->
                <div class="p-field p-col-12 p-md-12">
                  <label for="">Full Name</label>
                </div>
                <div class="p-field p-col-12 p-md-4">
                      <span class="p-float-label">
                        <InputText v-model.trim="firstName" id="firstName"/>
                        <label for="firstName">First Name</label>
                       </span>
                </div>
                <div class="p-field p-col-12 p-md-4">
                       <span class="p-float-label">
                         <InputText v-model.trim="middleName" id="middleName"/>
                         <label for="middleName">Middle Name</label>
                       </span>
                </div>
                <div class="p-field p-col-12 p-md-4">
                      <span class="p-float-label">
                        <InputText v-model.trim="lastName" id="lastName"/>
                         <label for="lastName">Last Name</label>
                      </span>
                </div>
              </div>
              <hr/>
              <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
                <div class="p-field p-col-12 p-md-4">
                  <label for="employeeNumber">Employee Id</label>
                  <InputText id="employeeNumber"/>
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label for="license">License Number</label>
                  <InputText id="license"/>
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label for="expiryDate">License Expiry Date</label>
                  <date-picker v-model="licenseExpiryDate" valueType="format" v-if="!englishDateEnabled"/>
                  <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="expiryDate"
                             v-model="licenseExpiryDate"/>
                </div>
              </div>
              <hr/>
              <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
                <div class="p-field p-col-12 p-md-4">
                  <label for="">Gender</label>
                  <div class="p-field p-col-12 p-md-6">
                    <Radiobutton id="male" value="Male" v-model="gender"/>
                    <label for="male">Male</label>
                    <Radiobutton id="female" value="Female" v-model="gender"/>
                    <label for="female">Female</label>
                  </div>
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label for="maritalStatus">Marital Status</label>
                  <Dropdown v-model="maritalStatus" :options="maritalList" optionLabel="name" placeholder="--Select--"
                            id="maritalStatus"/>
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label for="nationality">Nationality</label>
                  <Dropdown v-model="nationality" :options="nationalityList" optionLabel="name" placeholder="--Select--"
                            id="nationality"/>
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label for="dob">Date of Birth</label>
                  <date-picker v-model="dateOfBirth" valueType="format" v-if="!englishDateEnabled"/>
                  <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="dob"
                             v-model="dateOfBirth"/>
                </div>
              </div>
              <hr/>
              <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
                <div class="p-field p-col-12 p-md-1">
                  <Button class="p-button-raised" label="Save" icon="pi pi-save"/>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Contact" class="p-mt-2">
              <ContactDetails/>
            </TabPanel>
            <TabPanel header="Emergency Contact" class="p-mt-2">
              <emergencyContact/>
            </TabPanel>
            <TabPanel header="Dependents" class="p-mt-2">
              <dependents/>
            </TabPanel>
            <TabPanel header="Immigration" class="p-mt-2">
              <immigration/>
            </TabPanel>
            <TabPanel header="Job Description" class="p-mt-2">
              Job Description
            </TabPanel>
            <TabPanel header="Leave Allocation" class="p-mt-2">
              <leaveAllocation/>
            </TabPanel>
            <TabPanel header="Salary" class="p-mt-2">
              <salary/>
            </TabPanel>
            <TabPanel header="Report-to" class="p-mt-2">
              <reportTo/>
            </TabPanel>
            <TabPanel header="Qualifications" class="p-mt-2">
              <qualification/>
            </TabPanel>
            <TabPanel header="Document" class="p-mt-2">
              <documentUpload/>
            </TabPanel>
          </TabView>
        </template>
      </Card>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Card from 'primevue/card'
import Radiobutton from 'primevue/radiobutton'
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import ContactDetails from './contactDetails.vue'
import emergencyContact from './emergencyContact.vue'
import dependents from './dependents.vue'
import immigration from './immigration.vue'
import leaveAllocation from './leaveAllocation.vue'
import salary from './salary.vue'
import reportTo from './report-to.vue'
import qualification from './qualification.vue'
import documentUpload from './documentUpload.vue'
export default {
  name: 'employeeDetails',
  props: ['employeeDetails'],
  data() {
    return {
      firstName: '',
      middleName: '',
      lastName: '',
      gender: null,
      loading: false,
      editing: false,
      filters: {},
      maritalStatus: {},
      nationality: {},
      englishDateEnabled: true,
      dateOfBirth: null,
      licenseExpiryDate: null,
      maritalList: [{name: 'Single'}, {name: 'Married'}, {name: 'Others'}]
    }
  },
  computed: {
    nationalityList() {
      return this.$store.state.hr.nationalityList
    }
  },
  mounted() {
    this.findNationality()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async findNationality() {
      await this.$store.dispatch('loadHrMasterSetupList', 'Nationality')
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.licenseExpiryDate = this.$store.getters.nepaliNewDate
        this.dateOfBirth = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.licenseExpiryDate = new Date().toISOString().slice(0, 10)
      this.dateOfBirth = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#dob').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.dateOfBirth = $('#dob').val()
        }
      })
      $('#expiryDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.licenseExpiryDate = $('#expiryDate').val()
        }
      })
    }
  },
  components: {
    Button,
    InputText,
    TabView,
    TabPanel,
    Card,
    Radiobutton,
    Dropdown,
    DatePicker,
    InputMask,
    ContactDetails,
    emergencyContact,
    dependents,
    immigration,
    leaveAllocation,
    salary,
    reportTo,
    qualification,
    documentUpload
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// employeeDetails.vue?1d8989a1